import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCountries } from "../../../REDUX/actions/country";
import NewAdressCard from "./Address/NewAdressCard";
import AddAdress from "./Address/AddAdress";

function Adresse() {
  const dispatch = useDispatch();

  const { depot } = useSelector((state) => state?.depotReducer);

  useEffect(() => {
    dispatch(getCountries());
  }, [dispatch]);

  return (
    <div className="d-flex flex-column p-5">
      <div className="flex-1 d-flex flex-wrap gap-5">
        {depot?.attributes?.address?.data ? (
          <NewAdressCard
            key={depot?.attributes?.address?.data?.id}
            address={depot?.attributes?.address?.data}
            depotId={depot?.id}
            withSelectOption={false}
          />
        ) : (
          <AddAdress depotId={depot?.id} />
        )}
      </div>
    </div>
  );
}

export default Adresse;
